export function isIgnoreAuthPath(routePath) {
  let ignoreRoute = false

  if (!routePath || typeof routePath !== 'string') {
    return ignoreRoute
  }
  const ignoreRoutes = ['/forgot-password', '/reset-password', '/signin', '/api/healthz']
  ignoreRoute = !!ignoreRoutes.find((path) => routePath.startsWith(path))

  return ignoreRoute
}
